import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable, of} from "rxjs";
import {WaypointService} from "@services";
import {Waypoint, WaypointType} from "@model";
import {mergeMap, take} from "rxjs/operators";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "../app-routing.module";

export const WaypointListResolver: ResolveFn<Observable<Waypoint[]> | Waypoint[]> =
  (route: ActivatedRouteSnapshot,
   _: RouterStateSnapshot,
   waypointService: WaypointService = inject(WaypointService)): Observable<Waypoint[]> | Waypoint[] => {
    return +route.queryParams['raceId'] ? waypointService.findWaypoints(+route.queryParams['raceId']) : [];
  }

export const MeasurementsWaypointListResolver: ResolveFn<Observable<Waypoint[]> | Waypoint[]> =
  (route: ActivatedRouteSnapshot,
   _: RouterStateSnapshot,
   waypointService: WaypointService = inject(WaypointService)): Observable<Waypoint[]> | Waypoint[] => {
    return +route.queryParams['eventId'] ? waypointService.findMeasurementWaypoints(+route.queryParams['eventId']) : [];
  }


export const MeasurementsWaypointResolver: ResolveFn<Observable<Waypoint> | Waypoint> | any =
    (route: ActivatedRouteSnapshot,
     state: RouterStateSnapshot,
     router: Router,
     waypointService: WaypointService = inject(WaypointService)): Observable<Waypoint> | Waypoint | any => {
        const eventId = route.queryParams['eventId'] ? +route.queryParams['eventId'] : undefined;
        const waypointId = route.queryParams['waypointId'] ? route.queryParams['waypointId'] : undefined;

        if (waypointId && eventId) {
            return waypointService.findMeasurementWaypoint(
                eventId, waypointId)
                .pipe(
                    take(1),
                    mergeMap((res: Waypoint | undefined) => {
                        if (res && res.waypointTypeId !== WaypointType.START_WAYPOINT) {
                            return of(res);
                        } else {
                            router.navigate([LANDING_ROUTE]);
                            return EMPTY;
                        }
                    })
                );
        }
        else {
            router.navigate([ORGANISER_DASHBOARD]);
            return EMPTY
        }
    }